import { useEffect } from 'react'
import { FormControl, Grid, TextField, Typography } from '@mui/material'

// Imports custom
import { MoraPendienteTable } from './MoraPendienteTable'

export const MoraExemption = ({ useFetchInit }) => {

    const {
        Forms,
        Helpers,
        globalStates
    } = useFetchInit

    const { formOpeningMode } = globalStates
    const isReadOnly = (formOpeningMode === 'READONLY')

    const { FormRequestGlobal: { formState, setFormState } } = Forms
    const { convertToFloat, numberFormatter } = Helpers

    // Recalcula el total a exonerar cada vez que cambia la seleccion de cuotas o el porcentaje.
    // El monto final que realmente se aplica lo vuelve a calcular el servidor al crear la
    // gestion (y de nuevo al aprobarla, con tope de seguridad); esto es solo para que el gestor
    // vea una previsualizacion antes de enviar.
    useEffect(() => {
        if (isReadOnly) return

        const porcentaje = formState.clean_porcentaje_exoneracion || 0

        // Redondear por renglon ANTES de sumar, igual que el backend (MgmtManagementAction.js,
        // saveMoraExemptionDB: monto_exonerado = Math.round((mora_pendiente * porcentaje / 100) *
        // 100) / 100 por cuota). Redondear la suma en vez del renglon (como se hacia antes)
        // desfasaba el total mostrado del que realmente queda en cred_gestiones.exoneracion_mora
        // por un centavo -- y con la validacion todo-o-nada de la aprobacion (RCA "Exoneracion de
        // mora multicuota"), ese centavo de diferencia hace fallar la gestion.
        const totalExonerado = (formState.rowSelectedExoneracion || [])
            .reduce((acc, row) => {
                const moraPendienteCuota = convertToFloat(String(row.mora_pendiente ?? 0))
                return acc + Math.round((moraPendienteCuota * porcentaje / 100) * 100) / 100
            }, 0)

        setFormState(prevState => ({
            ...prevState,
            total_exoneracion: numberFormatter.format(totalExonerado),
            clean_total_exoneracion: totalExonerado
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState.rowSelectedExoneracion, formState.clean_porcentaje_exoneracion])

    const handleChangePorcentaje = (event) => {
        const { value } = event.target
        const clean = Math.min(100, Math.max(0, Math.round(convertToFloat(String(value)) * 100) / 100))

        setFormState(prevState => ({
            ...prevState,
            porcentaje_exoneracion: clean,
            clean_porcentaje_exoneracion: clean
        }))
    }

    return (
        <>
            <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
                Cuotas con mora pendiente
            </Typography>
            <div className="border-bottom border-dark"></div>
            <MoraPendienteTable useFetchInit={useFetchInit} />

            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 2, mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="porcentaje_exoneracion">% Exoneracion</label>
                        <TextField
                            id='porcentaje_exoneracion'
                            name='porcentaje_exoneracion'
                            value={formState.porcentaje_exoneracion}
                            onChange={handleChangePorcentaje}
                            size='small'
                            placeholder='% Exoneracion'
                            hiddenLabel
                            type='number'
                            variant='outlined'
                            InputProps={{ readOnly: isReadOnly }}
                            inputProps={{ min: 0, max: 100, step: 0.01 }}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="total_exoneracion">
                            {!isReadOnly
                                ? 'Total a exonerar'
                                : (formState.aprobacion_check === 'Aprobado' ? 'Total exonerado (aprobado)' : 'Total solicitado a exonerar')}
                        </label>
                        <TextField
                            id='total_exoneracion'
                            name='total_exoneracion'
                            value={formState.total_exoneracion}
                            size='small'
                            placeholder='Total a exonerar'
                            hiddenLabel
                            type='text'
                            variant='filled'
                            InputProps={{ readOnly: true }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
